import { todayInBogota, validateFrequencyFilters } from "./frequencyModel";

export function yesterdayInBogota() {
  const date = new Date(`${todayInBogota()}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() - 1);
  return date.toISOString().slice(0, 10);
}

export function validateVipUsageFilters(filters) {
  const invalid = validateFrequencyFilters(filters);
  if (invalid) return invalid;
  const latestDate = yesterdayInBogota();
  if (filters.startDate > latestDate || filters.endDate > latestDate)
    return "Uso de VIP solo permite consultar hasta ayer. No se pueden seleccionar hoy ni fechas futuras.";
  return null;
}
